import React from 'react';
import { Checkbox, Tooltip, Modal, useTooltip, Typography, Button } from '@vtblife/uikit';
import { Toggle } from '@vtblife/uikit/legacy';
import Icon from '@vtblife/uikit-icons';

import {
    AuthorTypeOptionsWithRealtor,
    LayoutImageOptions,
    OnlineView,
    PhotoOptions
} from '@search/filter-enums/enums';

import { MobileFilter2 } from '../../../filter/MobileFilter2';
import { AuthorFilter, LayoutImageOptionsFilter, OnlineViewFilter, PhotoOptionsFilter } from '../../../../models/Filter';

interface IAdditionallyOptionsFilter {
    photoFilter: PhotoOptionsFilter;
    onlineViewFilter: OnlineViewFilter;
    layoutImageOptionFilter?: LayoutImageOptionsFilter;
    pitFilter?: AuthorFilter;
    handleChange: (filter: PhotoOptionsFilter | OnlineViewFilter | LayoutImageOptionsFilter | AuthorFilter) => void;
    classNameGroup?: string;
    classNameSubGroup?: string;
    classNameSeparate?: string;
    isMap?: boolean;
}

const style = {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '16px'
};

export const MobileAdditionallyOptionsFilterView: React.FC<IAdditionallyOptionsFilter> = ({
    photoFilter,
    onlineViewFilter,
    layoutImageOptionFilter,
    pitFilter,
    handleChange,
    classNameGroup,
    classNameSubGroup,
    classNameSeparate,
    isMap = false
}) => {
    const [ modal, setModal ] = React.useState(false);
    const { to, registerControl } = useTooltip();

    const [ toggle, setToggle ] = React.useState<boolean>(false);

    const onChangePhotoFilter = React.useCallback((newValue: boolean) => {
        if (newValue) handleChange(new PhotoOptionsFilter(PhotoOptions.WITH_PHOTO));
        else handleChange(new PhotoOptionsFilter());
    }, [ handleChange ]);

    const onChangeOnlineViewFilter = React.useCallback((newValue: boolean) => {
        if (newValue) {
            handleChange(new OnlineViewFilter(OnlineView.HAS_ANY));
        } else {
            handleChange(new OnlineViewFilter());
        }
    }, [ handleChange ]);

    const onChangeLayoutImageOptionFilter = React.useCallback((newValue: boolean) => {
        if (newValue) handleChange(new LayoutImageOptionsFilter([ LayoutImageOptions.HAS_ANY ]));
        else handleChange(new LayoutImageOptionsFilter());
    }, [ handleChange ]);

    const onChangePitFilter = React.useCallback((newValue: boolean) => {
        setToggle(newValue);

        if (newValue) handleChange(new AuthorFilter([ AuthorTypeOptionsWithRealtor.PIT ]));
        else handleChange(new AuthorFilter());
    }, [ handleChange ]);

    const pitNode = isMap ? (
        <div
            ref={registerControl}
            style={style}
        >
            <Typography variant='primary-alone' onClick={() => onChangePitFilter(! toggle)}>
                Объект имущественных торгов
                <span style={{ marginLeft: 8 }}>
                    <Icon
                        name='question-circle'
                        color='#746D9380'
                        size='m'
                    />
                </span>
            </Typography>
            <Toggle
                value={pitFilter?.author.includes(AuthorTypeOptionsWithRealtor.PIT) ?? false}
                onChange={onChangePitFilter}
            />
            <Tooltip placement='body' to={to}>
                Покупка имущества на&nbsp;торгах доступна как для физических, так и&nbsp;для юридических лиц,
                и&nbsp;дает возможность приобрести недвижимость по&nbsp;стоимости ниже рыночной
            </Tooltip>
        </div>
    ) : (
        <div style={style}>
            <Typography variant='primary-alone'>
                Объект имущественных торгов
                <span style={{ marginLeft: 8 }} onClick={() => setModal(true)}>
                    <Icon
                        name='question-circle'
                        color='#746D9380'
                        size='m'
                    />
                </span>
            </Typography>
            <Toggle
                value={pitFilter?.author.includes(AuthorTypeOptionsWithRealtor.PIT) ?? false}
                onChange={onChangePitFilter}
            />
        </div>
    );

    return (<MobileFilter2>
        <div className={classNameGroup}>
            <div className={classNameSubGroup}>
                <Checkbox
                    name='photo'
                    value={photoFilter.photoOption === PhotoOptions.WITH_PHOTO}
                    onChange={onChangePhotoFilter}
                    variant='filter'
                    block
                >
                    Только с фото
                </Checkbox>
            </div>
            <div className={classNameSubGroup}>
                <Checkbox
                    name='onlineView'
                    value={onlineViewFilter?.onlineView === OnlineView?.HAS_ANY}
                    onChange={onChangeOnlineViewFilter}
                    variant='filter'
                    block
                >
                    Онлайн показ
                </Checkbox>
            </div>
            {layoutImageOptionFilter ? (
                <div className={classNameSubGroup}>
                    <Checkbox
                        name='layout-image'
                        value={layoutImageOptionFilter.layoutImageOption.includes(LayoutImageOptions.HAS_ANY)}
                        onChange={onChangeLayoutImageOptionFilter}
                        variant='filter'
                        block
                    >
                        Только с планировкой
                    </Checkbox>
                </div>
            ) : null}
            {/*{pitFilter ? pitNode : null}*/}
        </div>
        {/*{! isMap ? (*/}
        {/*    <Modal*/}
        {/*        size='s'*/}
        {/*        opened={modal}*/}
        {/*        onClose={() => setModal(false)}*/}
        {/*    >*/}
        {/*        <Typography variant='primary-alone' bold>*/}
        {/*            Имущественные торги*/}
        {/*        </Typography>*/}
        {/*        <Typography variant='primary-alone' className={classNameSeparate}>*/}
        {/*            Покупка имущества на&nbsp;торгах доступна как для физических, так и&nbsp;для юридических лиц и&nbsp;даёт возможность приобрети недвижимость по&nbsp;стоимости ниже рыночной*/}
        {/*        </Typography>*/}
        {/*        <Button variant='secondary' fullWidth onClick={() => setModal(false)}>*/}
        {/*            Свернуть*/}
        {/*        </Button>*/}
        {/*    </Modal>*/}
        {/*) : null}*/}
    </MobileFilter2>);
};
